/* CLEARWAKE: Verhalten der einheitlichen Slider-Navigation.
   Container: [data-cw-slider], scrollende Liste: [data-cw-slider-track] (position: relative),
   Navigation: [data-cw-snav] aus snippets/clearwake-slider-nav.liquid. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.cwSliderInit === '1') return;
    var track = root.querySelector('[data-cw-slider-track]');
    var nav = root.querySelector('[data-cw-snav]');
    if (!track || !nav) return;
    root.dataset.cwSliderInit = '1';
    var prev = nav.querySelector('[data-cw-snav-prev]');
    var next = nav.querySelector('[data-cw-snav-next]');
    var dots = nav.querySelectorAll('.cw-snav__dot');
    var items = track.children;

    function padLeft() { return parseFloat(window.getComputedStyle(track).paddingLeft) || 0; }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function current() {
      if (track.scrollLeft >= maxScroll() - 4) return items.length - 1;
      var best = 0, dist = Infinity, p = padLeft();
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - p - track.scrollLeft);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      nav.hidden = !overflow;
      if (!overflow) return;
      var c = current();
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= maxScroll() - 4;
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === c);
    }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: items[i].offsetLeft - padLeft(), behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(current() - 1); });
    next.addEventListener('click', function () { go(current() + 1); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-cw-slider]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (window.__cwSliderLoaded) { initAll(); return; }
  window.__cwSliderLoaded = true;
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
